import activeProcess from './activeProcess'
import approvedProcess from './approvedProcess'
import chartOptions from './chartOptions'
import dashboard from './dashboard'
import departmentNames from './departmentNames'
import finalizedRmcs from './finalizedRmcs'
import gapCharts from './gapCharts'
import highRiskProcess from './highRiskProcess'
import inactiveProcess from './inactiveProcess'
import lowRiskProcess from './lowRiskProcess'
import mediumRiskProcess from './mediumRiskProcess'
import mountAcceptanceRows from './mountAcceptanceRows'
import mountComplianceRows from './mountComplianceRows'
import mountGapPanels from './mountGapPanels'
import mountGapTabs from './mountGapTabs'
import mountProgressRows from './mountProgressRows'
import mountRowName from './mountRowName'
import onTimeRmcs from './onTimeRmcs'
import overdueRmcs from './overdueRmcs'
import overviewPdfTable from './overviewPdfTable'
import pendingRmcs from './pendingRmcs'
import processCharts from './processCharts'
import processRiskCounts from './processRiskCounts'
import reprovedProcess from './reprovedProcess'
import riskAcceptedRmcs from './riskAcceptedRmcs'
import rncCharts from './rncCharts'
import severeRiskProcess from './severeRiskProcess'
import totalProcess from './totalProcess'

export default {
  ...dashboard,
  activeProcess,
  approvedProcess,
  chartOptions,
  finalizedRmcs,
  gapCharts,
  departmentNames,
  highRiskProcess,
  inactiveProcess,
  lowRiskProcess,
  mediumRiskProcess,
  mountAcceptanceRows,
  mountComplianceRows,
  mountGapPanels,
  mountGapTabs,
  mountProgressRows,
  mountRowName,
  onTimeRmcs,
  overdueRmcs,
  overviewPdfTable,
  pendingRmcs,
  processCharts,
  processRiskCounts,
  reprovedProcess,
  riskAcceptedRmcs,
  rncCharts,
  severeRiskProcess,
  totalProcess,
}
